import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {CommonService} from '../../services/common.service'
import { APIService, myCurrency } from 'src/app/api.service';
import {DataService} from '../../services/data.service'
import { MultipleSelectItemComponent } from '../multiple-select-item/multiple-select-item.component';
import { Subscription } from 'rxjs';
import { CopyFromProductComponent } from '../copy-from-product/copy-from-product.component';
import { debug } from 'console';
import { ImportBOMComponent } from '../import-bom/import-bom.component';

@Component({
  selector: 'app-product-bom',
  templateUrl: './product-bom.component.html',
  styleUrls: ['./product-bom.component.scss']
})
export class ProductBOMComponent implements OnInit {

  constructor(private router: Router, public commonFun: CommonService, private apiService: APIService, 
    private dataSer: DataService, private modalService: NgbModal) {
    this.dataSer.BOMData.subscribe((value) => {
      this.dataSer.stockItems.subscribe((value) => {
        this.products = value;
      })
      if (this.products && this.products.length == 0) {
        this.apiService.getIDB('erp_inv', (productList: any) => {
          if (productList && productList.length > 0) {
            this.products = productList;
          }
        });
      }

      let val: any = value;
      if(val.productID) {
        this.productID = val.productID;
        this.BOMData = value;
        this.getData();
      }
    });
  }


  //#region "Declaration"
  @Input() BOMData: any;
  @Input() mdlRef: any;
  @Input() isProjectType: any = true;
  prductData: any = {
    productID: 0,
    productName: 'Blue LED Light',
    bom:[]
  }

  modalReference: any;
  jarvisData: any = [];
  productID: number = 0;
  products: any = [];
  agencyData: any = [];
  totalCost: number = 0;
  isEdit: boolean = false;
  right: any = [];
  isRateView: boolean = false;
  myCurrency: any = myCurrency();

  //#endregion

  ngOnInit(): void {
    // let productID = this.commonFun.GetParam("PID");
    // this.prductData.productID = productID;
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
    }
    
    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      console.log(this.right)
      if(!this.right.InvMstrs && !this.right.InvCfg && !this.right.InvRpts && !this.right.InvXns){
       window.location.href = "../../main.html#/home";
        return;
      }
      if(this.right.InvRateView.toString()  != "undefined"){
        this.isRateView = this.right.InvRateView
     }
    }

    this.dataSer.stockItems.subscribe((value) => {
      this.products = value;
    })
    if (this.products && this.products.length == 0) {
      this.apiService.getIDB('erp_inv', (productList: any) => {
        if (productList && productList.length > 0) {
          this.products = productList;
        }
      });
    }
 
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    if(this.BOMData.productID) {
      this.getData();
    }
  }


  getData() {
    this.totalCost = 0;
    let jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
          this.prductData.productID = this.BOMData.productID;;
          this.prductData.productName = this.BOMData.productName;
          if(this.BOMData.BOM){
            var selectedBOMItem = JSON.parse(this.BOMData.BOM);
          }
          this.prductData.bom = [];
          for (let i = 0; i < selectedBOMItem.length; i++) {
            let tmpPRD = this.products.filter((x: any) => x.ItemID == selectedBOMItem[i].IID);
            let reqQty: any = tmpPRD.length > 0 ? Number(selectedBOMItem[i].Qty).toFixed(tmpPRD[0].SKUPrecision) : Number(selectedBOMItem[i].Qty);
           if(tmpPRD.length > 0){
            this.prductData.bom.push({
              ItemID: selectedBOMItem[i].IID,
              ReqdQty: reqQty, //tmpPRD.length > 0 ? Number(selectedBOMItem[i].Qty).toFixed(tmpPRD[0].SKUPrecision) : Number(selectedBOMItem[i].Qty),
              TypeID: 1,
              Unit: selectedBOMItem[i].Unt,
              productName: tmpPRD.length > 0 ? tmpPRD[0].ItemName : '',
              productCode: tmpPRD.length > 0 ? tmpPRD[0].ItemCode : '',
              SKUPrecision: tmpPRD.length > 0 ? tmpPRD[0].SKUPrecision : '',
              purchRate: tmpPRD.length > 0 ? Number(tmpPRD[0].DefPurchRate) : 0
            });
            this.fn_calculateTotalCost(tmpPRD[0], reqQty);
           }           
          }

          // this.dataSer.dataTransfer.subscribe((value :any) => {
          //   if(value){
          //     this.prductData.productName = value.productName;
          //     let selectedBOMItem = JSON.parse(value.BOM);
          //     for (let i = 0; i < selectedBOMItem.length; i++) {
          //       let tmpPRD = this.products.filter((x: any) => x.ItemID == selectedBOMItem[i].IID);
          //       this.prductData.bom.push({
          //         ItemID: selectedBOMItem[i].IID,
          //         ReqdQty: selectedBOMItem[i].Qty,
          //         TypeID: 1,
          //         Unit: selectedBOMItem[i].Unt,
          //         productName: tmpPRD.length > 0 ? tmpPRD[0].ItemName : '',
          //         productCode: tmpPRD.length > 0 ? tmpPRD[0].ItemCode : ''
          //       });
          //     }
          //   }
          // });
    };

    // Selected Item show in Data
    this.dataSer.items.subscribe((value :any) => {
      if (value.length > 0) {
       let tempData =  this.prductData.bom.filter((x:any) => x.ItemID == value[0].ItemID)
       if(tempData.length == 0 ){
        let selecetdItems = value;
        for (let i = 0; i < selecetdItems.length; i++) {
          this.prductData.bom.push({
            ItemID: selecetdItems[i].ItemID,
            ReqdQty: '', //Number(0).toFixed(selecetdItems[i].SKUPrecision),
            TypeID: 1,
            Unit: selecetdItems[i].SKU,
            productName: selecetdItems[i].ItemName,
            productCode: selecetdItems[i].ItemCode,
            SKUPrecision: selecetdItems[i].SKUPrecision,
            purchRate: selecetdItems[i].DefPurchRate
          });
        }
      }  

      value = [];
    }    
    });
  }
  
  getSelectedItem(obj: any) {

  }

  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = 0; // Transaction Type
    this.modalReference.componentInstance.it = 0;
    this.modalReference.componentInstance.st = 0; // Store ID
    this.modalReference.componentInstance.rm = 0; // Show Raw-Material
    this.modalReference.componentInstance.ri = this.productID; // Remove this item
    this.modalReference.componentInstance.ft = 0; // From Transaction Page if 1 Then Yes else No
    
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.isEdit = true;
  }

  closeModal() {
    this.modalReference.close();
  }

  //fn_saveBOM() - BOM Save
  fn_saveBOM(){
    let tmpZeroQty = $.grep(this.prductData.bom, function(o: any){ return o.reqdQty == 0});
    if(tmpZeroQty.length > 0){
      this.apiService.successAlert("Please enter bom quantity more then zero.");
      return;
    }

    let tmpMissingQty = $.grep(this.prductData.bom, function(o: any) { 
      return o.ReqdQty === undefined || o.ReqdQty === null || o.ReqdQty === ''; 
    });

    if(tmpMissingQty.length > 0) {
      this.apiService.successAlert("Please enter valid quantity for the items.");
      return;
    }

    let finalBOM: any = [];
    this.prductData.bom.forEach(function(value:any){
      finalBOM.push({
        ItemID: value.ItemID,
        ReqdQty: value.ReqdQty,
        TypeID: value.TypeID,
        Unit: value.Unit
      });
      
    });

    let tempData = [{
      ItemID: this.prductData.productID,
      ChangeType: 'BOM',
      BOM: JSON.stringify(finalBOM),
      Byproducts: '[]',
      Stages: "",
      Units: '[]'
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setItemDetail',
      moduleID: 5,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successBOMEntry.bind(this), this.failureBOMResp.bind(this));
  }
  
  //failureBOMResp - failure handler
  failureBOMResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successBOMEntry - success  get handler
  successBOMEntry(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          }
          else{
            this.totalCost = 0
            for (let i = 0; i < this.prductData.bom.length; i++) {
              let tmpPRD = this.products.filter((x: any) => x.ItemID == this.prductData.bom[i].ItemID);  
              this.fn_calculateTotalCost(tmpPRD[0], this.prductData.bom[i].ReqdQty);
            }
            // this.router.navigateByUrl('/ProductDetail?PID=' + this.prductData.productID);
            if(this.mdlRef) {
              this.mdlRef.close('Done');
            }
            
            this.isEdit = false;
          }
        }
    }
  }

  goBack(){
    // window.history.back();
    this.mdlRef.close('Close');
  }

  prcisionCheck(obj: any) {
    obj.ReqdQty = this.commonFun.PrecisionwiseValue(obj.ReqdQty + '', obj.SKUPrecision);
  }

  removeBOM(ind: number){
    this.prductData.bom.splice(ind, 1);
    if(this.prductData.bom.length == 0){
      this.fn_saveBOM();
    }
  }

  copyFromProduct() {
    let tmpBomData: any = []
    this.modalReference = this.modalService.open(CopyFromProductComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = 2; // Copy BOM
    this.modalReference.componentInstance.ri = this.productID; // Remove this item
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if(result.length > 0) {
        tmpBomData = result;

        if(tmpBomData.length > 0) {
          for (let i = 0; i < tmpBomData.length; i++) {
            let tmpPRD = this.products.filter((x: any) => x.ItemID == tmpBomData[i].IID);
            this.prductData.bom.push({
              ItemID: tmpBomData[i].IID,
              ReqdQty: tmpPRD.length > 0 ? Number(tmpBomData[i].Qty).toFixed(tmpPRD[0].SKUPrecision) : Number(tmpBomData[i].Qty),
              TypeID: 1,
              Unit: tmpBomData[i].Unt,
              productName: tmpPRD.length > 0 ? tmpPRD[0].ItemName : '',
              productCode: tmpPRD.length > 0 ? tmpPRD[0].ItemCode : '',
              SKUPrecision: tmpPRD.length > 0 ? tmpPRD[0].SKUPrecision : ''
            });
          }
        }
        this.fn_saveBOM();
      }
      
    });
  }

  //fn_calculateTotalCost() - Calculate BOM Cost
  fn_calculateTotalCost(obj: any, reqQty: number){
    this.totalCost = Number(this.totalCost) + (Number(obj.DefPurchRate) * reqQty);
  }

  //fn_changeBOMQty() - Change BOM
  fn_changeBOMQty(){
      this.isEdit = true;
      this.prductData.bom.forEach(function(value:any){
        if(value.ReqdQty == 0){
          value.ReqdQty = "";
        }
      });
  }

//bom Print
openBOMPrint(){
  let prodID = this.commonFun.encryptData(this.productID);
  window.open('prodBOMPrint?ProductID=' + prodID, '_blank', 'Height= 600px, Width= 900px, Top= 50px, edge= Raised, center= Yes, help= No, status= No');
} 

// Import Item Modal Open
importBOM() {
  this.modalReference = this.modalService.open(ImportBOMComponent, { ariaLabelledBy: 'import-bom-title', windowClass: 'modalWidthSmall', backdrop: 'static', keyboard: false });
  this.modalReference.componentInstance.mdlRef = this.modalReference;
  this.modalReference.componentInstance.productID = this.prductData.productID;
  this.modalReference.componentInstance.availableBOM = this.prductData.bom;
  this.modalReference.result.then((result: any) => {
    if (result.action == 'Done') {
      this.prductData.bom = [ ...this.prductData.bom, ...result.data ];
      this.fn_changeBOMQty();
    }
  });
}

}
